export default __webpack_public_path__ + "static/media/priority.908de3a8.png";